// Happy Otter cart drawer behaviour (markup: snippets/ho-cart-drawer.liquid). Loaded on every page.
import { morphSection } from '@theme/section-renderer';
  (function () {
    if (window.__hoCart) return;
    window.__hoCart = true; // loaded once per page from layout/theme.liquid

    // Checkout gate. Razorpay Magic is loaded late on purpose (page speed), and a Checkout tap that lands
    // before Magic is ready falls through to Shopify's native checkout (reproduced 2026-11-02: tap 2.5s
    // after page open -> /checkouts/cn/...). Two layers:
    //  1. load Magic as soon as the cart has anything in it, so it's ready long before Checkout is tapped;
    //  2. if a tap still beats it, hold the tap, then flip the button to "tap to continue" once Magic is
    //     ready (Magic ignores replayed, untrusted clicks, so the shopper's next real tap goes to Magic).
    //     If Magic isn't up after GATE_MS, let them through to Shopify checkout instead of a dead button.
    // Capture phase, registered before Magic's own listeners, so once Magic is ready taps pass untouched.
    var GATE_MS = 8000;
    var CHECKOUT_SEL = 'button[name="checkout"], input[name="checkout"], a[href="/checkout"], a[href^="/checkout?"]';
    function magicReady() {
      return typeof window.Razorpay === 'function' && !!window.RazorpayMagicBtnConfig;
    }
    function loadMagic() {
      if (typeof window.__hoLoadRazorpay === 'function') window.__hoLoadRazorpay();
    }
    document.addEventListener('cart:update', loadMagic);
    if (document.querySelector('.hoc__checkout')) loadMagic(); // cart already has items
    // State lives on <html data-ho-checkout="busy|ready"> and the labels are pure CSS: the drawer redraw
    // rewrites the button's text and classes, but never touches <html>.
    function gateState(b, s) {
      var root = document.documentElement;
      if (s) root.dataset.hoCheckout = s; else delete root.dataset.hoCheckout;
      if (s === 'busy') b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy');
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest(CHECKOUT_SEL);
      if (!b) return;
      if (b.dataset.hoGate === 'pass') { delete b.dataset.hoGate; return; } // our own fallback replay
      if (magicReady()) { gateState(b, ''); return; } // Magic takes it from here
      e.preventDefault();
      e.stopImmediatePropagation();
      if (b.dataset.hoGate === 'wait') return; // already waiting, ignore repeat taps
      b.dataset.hoGate = 'wait';
      gateState(b, 'busy');
      loadMagic();
      var start = Date.now();
      (function check() {
        if (magicReady()) {
          setTimeout(function () { delete b.dataset.hoGate; gateState(b, 'ready'); }, 400); // let Magic wire its listeners
        } else if (Date.now() - start > GATE_MS) {
          gateState(b, ''); b.dataset.hoGate = 'pass'; b.click(); // fallback: Shopify checkout rather than a dead button
        } else {
          setTimeout(check, 150);
        }
      })();
    }, true);
    // back button from Razorpay restores the page from cache: reset any held button
    window.addEventListener('pageshow', function () {
      document.querySelectorAll(CHECKOUT_SEL).forEach(function (b) { delete b.dataset.hoGate; gateState(b, ''); });
    });

    function fmt(paise) {
      var r = Math.round(paise / 100);
      try { return '₹' + r.toLocaleString('en-IN'); } catch (e) { return '₹' + r; }
    }
    function sectionIds() {
      var ids = [];
      document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
        if (ids.indexOf(el.dataset.sectionId) === -1) ids.push(el.dataset.sectionId);
      });
      return ids.join(',');
    }

    // POST to the Ajax cart, asking Shopify for the re-rendered drawer in the same request.
    // Rejects with a readable message when Shopify refuses (sold out, stock limit, etc).
    function post(url, body) {
      body.sections = sectionIds();
      body.sections_url = window.location.pathname;
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (data) {
            if (!r.ok || data.status >= 400) {
              var err = new Error(data.description || data.message || 'Something went wrong. Please try again.');
              err.hoUser = true;
              throw err;
            }
            return data;
          });
        });
    }

    function morphMod_() { return Promise.resolve({ morphSection: morphSection }); }

    // Redraw the drawer from fresh section HTML. 'hydration' is the mode Horizon uses for its own drawer.
    function redraw(sections, cart) {
      var ids = sectionIds().split(',').filter(Boolean);
      var need = ids.filter(function (id) { return !(sections && sections[id]); });
      var fetchMissing = need.length
        ? fetch('/?sections=' + need.join(',')).then(function (r) { return r.json(); }).catch(function () { return {}; })
        : Promise.resolve({});
      var getCart = cart ? Promise.resolve(cart) : fetch('/cart.js').then(function (r) { return r.json(); });
      return Promise.all([morphMod_(), fetchMissing, getCart]).then(function (out) {
        var morphSection = out[0].morphSection, extra = out[1] || {}, c = out[2];
        ids.forEach(function (id) {
          var html = (sections && sections[id]) || extra[id];
          if (html) { try { morphSection(id, html, 'hydration', { injectStylesheet: true }); } catch (e) {} }
        });
        // The dialog itself sits outside the redrawn area; keep its empty-state class honest
        document.querySelectorAll('.cart-drawer__dialog').forEach(function (d) {
          d.classList.toggle('cart-drawer--empty', !c.item_count);
        });
        return c;
      });
    }

    // After our own change: redraw, then tell the rest of the theme (cart bubble etc.)
    function refresh(res) {
      return redraw(res && res.sections).then(function (cart) {
        var source = document.querySelector('cart-items-component[data-section-id]') || document;
        var ev = new Event('cart:update', { bubbles: true });
        ev.detail = { resource: cart, sourceId: 'ho-cart', data: { itemCount: cart.item_count, source: 'ho-cart', sections: (res && res.sections) || {} } };
        source.dispatchEvent(ev);
        return cart;
      });
    }

    // Any OTHER cart change (Add to cart on a product page, quick add, etc): redraw once things settle,
    // so the drawer can never be left showing a stale or empty cart.
    var syncTimer = null;
    document.addEventListener('cart:update', function (e) {
      if (e.detail && (e.detail.sourceId === 'ho-cart' || (e.detail.data && e.detail.data.source === 'ho-cart'))) return;
      var sections = e.detail && e.detail.data && e.detail.data.sections;
      clearTimeout(syncTimer);
      syncTimer = setTimeout(function () { redraw(sections); }, 60);
    });
    // Back/forward cache: a restored page may hold an old drawer
    window.addEventListener('pageshow', function (e) { if (e.persisted) redraw(null); });

    function busy(root, on) { if (root) root.classList.toggle('is-busy', on); }

    // One cart change at a time; double taps are ignored instead of racing each other
    var locked = false;
    function run(root, job) {
      if (locked) return;
      locked = true;
      busy(root, true);
      clearAlert();
      return job().catch(function (err) {
        showAlert(err && err.hoUser ? err.message : 'Something went wrong. Please try again.');
        return redraw(null);
      }).finally(function () {
        locked = false;
        document.querySelectorAll('[data-ho-cart]').forEach(function (r) { busy(r, false); });
      });
    }

    var alertText = '';
    function clearAlert() { alertText = ''; paintAlert(); }
    function showAlert(msg) { alertText = msg; paintAlert(); }
    function paintAlert() {
      document.querySelectorAll('[data-ho-cart]').forEach(function (root) {
        var el = root.querySelector('.hoc__alert');
        if (!alertText) { if (el) el.remove(); return; }
        if (!el) {
          el = document.createElement('p');
          el.className = 'hoc__alert';
          el.setAttribute('role', 'alert');
          var scroll = root.querySelector('.hoc__scroll');
          (scroll || root).insertBefore(el, (scroll || root).firstChild);
        }
        if (el.textContent !== alertText) el.textContent = alertText;
      });
    }

    document.addEventListener('click', function (e) {
      var root = e.target.closest('[data-ho-cart]');
      if (!root) return;

      var qtyBtn = e.target.closest('[data-ho-qty]');
      var rmBtn = e.target.closest('[data-ho-remove]');
      if (qtyBtn || rmBtn) {
        var line = e.target.closest('[data-line]');
        if (!line) return;
        var qty = rmBtn ? 0 : Math.max(0, +line.dataset.qty + +qtyBtn.dataset.hoQty);
        run(root, function () { return post('/cart/change.js', { line: +line.dataset.line, quantity: qty }).then(refresh); });
        return;
      }

      var addBtn = e.target.closest('[data-ho-add]');
      if (addBtn) {
        if (locked) return;
        addBtn.disabled = true;
        addBtn.textContent = 'Adding…';
        run(root, function () {
          return post('/cart/add.js', { items: [{ id: +addBtn.dataset.hoAdd, quantity: 1 }] }).then(refresh)
            .catch(function (err) { addBtn.disabled = false; addBtn.textContent = '+ Add'; throw err; });
        });
        return;
      }

      if (e.target.closest('[data-ho-promo]')) {
        promoOpen = !promoOpen;
        syncPromo(root);
        if (promoOpen) { var inp = root.querySelector('#hoc-promo-input'); if (inp) inp.focus(); }
        return;
      }

      var rmCode = e.target.closest('[data-ho-code-remove]');
      if (rmCode) {
        var panel = root.querySelector('[data-ho-promo-panel]');
        var left = codesOf(panel).filter(function (c) { return c.toLowerCase() !== rmCode.dataset.hoCodeRemove.toLowerCase(); });
        run(root, function () { return post('/cart/update.js', { discount: left.join(',') }).then(refresh); });
      }
    });

    // Promo codes: applied to the Shopify cart, which Razorpay Magic Checkout carries through.
    // Shopify decides eligibility; codes it rejects are taken back off so the cart never holds a dead code.
    var promoOpen = false;
    var promoMsg = null;
    function codesOf(panel) { return ((panel && panel.dataset.codes) || '').split(',').filter(Boolean); }
    function syncPromo(root) {
      var panel = root.querySelector('[data-ho-promo-panel]');
      var btn = root.querySelector('[data-ho-promo]');
      if (!panel) return;
      if (panel.hidden === promoOpen) panel.hidden = !promoOpen;
      if (btn) btn.setAttribute('aria-expanded', promoOpen ? 'true' : 'false');
      var msg = panel.querySelector('[data-ho-promo-msg]');
      if (msg) {
        var text = promoMsg ? promoMsg.text : '';
        if (msg.textContent !== text) msg.textContent = text;
        msg.classList.toggle('is-error', !!(promoMsg && promoMsg.error));
        msg.classList.toggle('is-ok', !!(promoMsg && !promoMsg.error));
      }
    }
    document.addEventListener('submit', function (e) {
      var form = e.target.closest && e.target.closest('[data-ho-promo-form]');
      if (!form) return;
      e.preventDefault();
      var root = form.closest('[data-ho-cart]');
      var panel = root.querySelector('[data-ho-promo-panel]');
      var code = (form.elements.code.value || '').trim();
      if (!code) { promoMsg = { text: 'Enter a code first.', error: true }; syncPromo(root); return; }
      var existing = codesOf(panel);
      if (existing.some(function (c) { return c.toLowerCase() === code.toLowerCase(); })) {
        promoMsg = { text: code.toUpperCase() + ' is already applied.', error: false }; syncPromo(root); return;
      }
      var hadBundle = +panel.dataset.auto > 0;
      if (locked) return;
      locked = true;
      busy(root, true);
      post('/cart/update.js', { discount: existing.concat(code).join(',') }).then(function (res) {
        var hit = (res.discount_codes || []).filter(function (c) { return c.code.toLowerCase() === code.toLowerCase(); })[0];
        if (hit && hit.applicable) {
          // A new code can knock out an earlier one it doesn't combine with; drop the dead ones and say so
          var dead = (res.discount_codes || []).filter(function (c) { return !c.applicable; }).map(function (c) { return c.code; });
          promoMsg = {
            text: hit.code.toUpperCase() + ' applied.' + (dead.length ? ' It replaces ' + dead.join(', ').toUpperCase() + ' (they can\'t be combined).' : ''),
            error: false
          };
          if (!dead.length) return refresh(res);
          var live = (res.discount_codes || []).filter(function (c) { return c.applicable; }).map(function (c) { return c.code; });
          return post('/cart/update.js', { discount: live.join(',') }).then(refresh);
        }
        promoMsg = {
          text: existing.length
            ? "That code can't be used together with " + existing.join(', ').toUpperCase() + ". Remove it first to try this one."
            : hadBundle
              ? "That code doesn't work with this cart. It may not combine with the bundle savings already applied."
              : "That code isn't valid for this cart.",
          error: true
        };
        return post('/cart/update.js', { discount: existing.join(',') }).then(refresh);
      }).catch(function () {
        promoMsg = { text: "Couldn't check that code. Please try again.", error: true };
        syncPromo(root);
      }).finally(function () {
        locked = false;
        document.querySelectorAll('[data-ho-cart]').forEach(function (r) { busy(r, false); });
      });
    });

    // Backup only: products without hand-picked pairs fall back to Shopify's related products
    var recCache = {};
    function renderPairs(root) {
      var box = root.querySelector('[data-ho-pairs]');
      var list = root.querySelector('[data-ho-pairs-list]');
      var pid = root.dataset.firstProduct;
      // Horizon morphs the drawer in place on every cart change, which empties this list but keeps the node,
      // so re-render whenever the list is empty rather than once per element
      if (!box || !box.hasAttribute('data-fallback') || !list || !pid || list.children.length || list.__loading === pid) return;
      list.__loading = pid;
      var inCart = (root.dataset.inCart || '').split(',');
      var get = recCache[pid] || (recCache[pid] = fetch('/recommendations/products.json?product_id=' + pid + '&limit=10&intent=related').then(function (r) { return r.json(); }));
      get.then(function (data) {
        var picks = (data.products || []).filter(function (p) {
          return p.available && inCart.indexOf(String(p.id)) === -1;
        }).slice(0, 3);
        list.__loading = null;
        if (!picks.length) return;
        list.innerHTML = picks.map(function (p) {
          var v = (p.variants || []).filter(function (x) { return x.available; })[0] || p.variants[0];
          var name = p.title.split('|')[0].trim();
          var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
          return '<div class="hoc__pair">' +
            '<a class="hoc__pair-img" href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy" width="80" height="80">' : '') + '</a>' +
            '<div class="hoc__pair-txt"><a href="' + p.url + '">' + name.replace(/</g, '&lt;') + '</a><span>' + fmt(v.price) + '</span></div>' +
            '<button type="button" class="hoc__pair-add" data-ho-add="' + v.id + '">+ Add</button>' +
          '</div>';
        }).join('');
        box.hidden = false;
      }).catch(function () { list.__loading = null; });
    }
    var scanQueued = false;
    function scan() {
      scanQueued = false;
      document.querySelectorAll('[data-ho-cart]').forEach(function (root) { renderPairs(root); syncPromo(root); });
      if (alertText) paintAlert();
    }
    new MutationObserver(function () {
      if (scanQueued) return;
      scanQueued = true;
      requestAnimationFrame(scan);
    }).observe(document.documentElement, { childList: true, subtree: true });
    scan();
  })();
